<template>
  <hm-content title="">
    <div class="table-panel">
      <el-button type="primary" size="small" class="mr10" @click="add"
        >添加通知</el-button
      >
    </div>
    <div class="table">
      <el-table
        stripe
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
        border
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="通知消息名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="updateTime"
          label="更新时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="通知时间"
          width="300px"
        >
          <template slot-scope="scope">
            {{ scope.row.startTime }}至{{ scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="storeCode"
            label="发放小程序"
        >
          <template slot-scope="scope">
            {{ scope.row.toApp == "WYHX" ? "我要核销" : "禾销" }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeCode"
          label="通知对象"
        >
          <template slot-scope="scope">

            <div v-if="scope.row.toApp == 'WYHX'">
              <div v-if="scope.row.isAll">
                全部商户
              </div>
              <div v-else>
                部分商户
              </div>
            </div>
            <div v-if="scope.row.toApp == 'HEX'">
              <div v-if="scope.row.isAll">
                全部供货商
              </div>
              <div v-else>
                部分供货商
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              type="text"
              @click="edit(scope.row)"
              class="blue"
              >编辑</el-button
            >
            <el-button
                size="small"
                type="text"
                @click="copy(scope.row)"
                class="blue"
            >复制</el-button
            >
            <el-button size="small" type="text" @click="del(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="handleClose"
    >
      <el-dialog
      width="80%"
      title="商户"
      :visible.sync="innerDialogVisible"
      append-to-body>
        <el-table
        v-if="ruleForm.isAll == false"
        :data="newStores"
        @selection-change="getChecked"
        style="width: 100%"
        id="table"
        size="small"
        border
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeName"
          label="商户店铺"
        ></el-table-column>
        <!-- <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="searchStore(scope.row)"
              >查询店铺</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
      <div class="hm-pagination">
      <el-pagination
        background
        :total="storesTotal"
        :page-size="40"
        @current-change="storePaging"
        layout="total,  prev, pager, next, jumper"
        :current-page="storeCurrent"
      ></el-pagination>
      <span slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button @click="addAllStore" size="small" type="primary">
          添加</el-button
        >
      </span>
    </div>
      </el-dialog>
      <div class="flex">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          :inline="false"
          label-width="130px"
        >
          <el-form-item label="通知消息名称" prop="name">
            <el-input
              style="width: 350px"
              maxlength="25"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.name"
              placeholder="请输入模板名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="通知时间" prop="activityDate">
            <el-date-picker
              :default-time="['00:00:00', '23:59:59']"
              v-model="ruleForm.activityDate"
              type="datetimerange"
              align="right"
              start-placeholder="活动开始时间"
              end-placeholder="活动结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              style="width: 350px"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="发放小程序" prop="isAll">
            <el-radio-group v-model="ruleForm.toApp" @change="changeToApp" size="small">
              <el-radio :label="'WYHX'">我要核销</el-radio>
              <el-radio :label="'HEX'">禾销</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="通知对象" prop="isAll">
            <div v-if="ruleForm.toApp == 'WYHX'">
              <el-radio-group v-model="ruleForm.isAll" size="small">
                <el-radio :label="true">全部商户</el-radio>
                <el-radio :label="false">指定商户</el-radio>
              </el-radio-group>
              <div class="flex">
                <el-input v-model="storename" v-show="!ruleForm.isAll"
                    size="small"
                    clearable
                    style="width: 350px"
                    class="mr10"
                    ref="storeref"
                    placeholder="请选择商户"></el-input>
                <!-- <el-select
                    v-show="!ruleForm.isAll"
                    size="small"
                    clearable
                    style="width: 350px"
                    class="mr10"
                    ref="storeref"
                    placeholder="请选择商户"
                    v-model="ruleForm.storeCodeList"
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="remoteMethod"
                    :loading="loading"
                    @change="storerefChange"
                    v-el-select-loadmore="loadmore"
                >
                  <el-option
                      :label="item.storeName"
                      :value="item.storeCode"
                      v-for="item in storeBasicList"
                      :key="item.storeCode"
                  >
                  </el-option>
                </el-select> -->
                
                <div class="table">
      
    </div>
                <div class="flex" style="display: flex;flex-flow: row nowrap;align-items: center;justify-content: center;" v-if="!ruleForm.isAll">
                  <el-button v-if="!ruleForm.isAll" style="height: 76%;" type="primary" size="mini" class="mr10" @click="searchAll"
        >搜索</el-button
      >
                  <div @click="outputExcel" class="delete mr20 pointer">
                    <span class="delete-icon hmicon icon-daochu"></span>
                    导出模板
                  </div>
                  <div class="delete mr20 pointer open-file">
                    <span class="delete-icon hmicon icon-daoru"></span>
                    导入商户
                    <input
                      type="file"
                      @change="importf"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    />
                  </div>
                </div>  
              </div>
            </div>
            <div v-else>
              <el-radio-group v-model="ruleForm.isAll" size="small">
                <el-radio :label="true">全部商户</el-radio>
                <el-radio :label="false">指定供货商</el-radio>
              </el-radio-group>
              <div>
                <el-select
                    v-show="!ruleForm.isAll"
                    size="small"
                    clearable
                    style="width: 350px"
                    class="mr10"
                    ref="storeref"
                    placeholder="请选供货商"
                    v-model="ruleForm.storeCodeList"
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="remoteMethodSupplier"
                    :loading="loading"
                    @change="storerefChange"
                    v-el-select-loadmore="loadmore"
                >
                  <el-option
                      :label="item.storeName"
                      :value="item.storeCode"
                      v-for="item in storeBasicList"
                      :key="item.storeCode"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-table
        v-if="ruleForm.isAll == false"
        :data="ruleForm.storeCodeList.slice((supplierCurrent - 1)*pageSize,   supplierCurrent*pageSize)"
        style="width: 100%"
        size="small"
        border
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeName"
          label="商户店铺"
        ></el-table-column>
        <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="removeSupplier(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
          <div class="hm-pagination" v-if="ruleForm.isAll == false">
      <el-pagination
        background
        :total="supplierTotal"
        :page-size="pageStoreSize"
        @current-change="supplierPaging"
        layout="total, prev, pager, next, jumper"
        :current-page="supplierCurrent"
      ></el-pagination>
    </div>
          </el-form-item>
          <el-form-item v-if="ruleForm.isAll == false">
            
          </el-form-item>
          <el-form-item label="通知消息内容" prop="content">
            <hm-rich-editor
              v-model="ruleForm.content"
              :html="ruleForm.content"
            />
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button @click="submitForm('ruleForm')" size="small" type="primary">
          确 认</el-button
        >
        <el-button size="small" @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="errValidStore">
      <div slot="title">
        导入失败提示
        <span class="danger"
          >商户名有误、商户名重复或者商户名不属于对应供应商会导致导入失败</span
        >
      </div>
      <div>
        <div class="flex flex-between">
          <div>
            您有
            <span class="error">{{ errStoreResult.length }}</span
            >条数据导入失败
          </div>
          <!-- <div>
            您有
            <span class="success"> {{ succInputResult.length }}</span
            >条数据导入成功！
          </div> -->
        </div>
        <el-table
          :data="errStoreResult"
          border
          class="small-table"
          max-height="500px"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户名称"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmRichEditor from "@/components/HmRichEditor";
import { arrayUnique2 } from "@/utils/utils";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        SELECTWRAP_DOM.addEventListener("scroll", function() {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      },
    },
  },
  components: {
    HmRichEditor,
  },
  data() {
    const storeCodeListFun = (rule, val, callback) => {
      if (!this.ruleForm.isAll) {
        if (!this.ruleForm.storeCodeList) {
          return callback(new Error("请选择商户！"));
        }
      }
      callback();
    };
    return {
      more: false,
      storename: "",
      storeBasicList: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur",
          },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        activityDate: {
          // validator: actDate,
          message: "请选择时间段",
          trigger: "blur",
          required: true,
        },
        isAll: [
          {
            validator: storeCodeListFun,
            message: "请选择通知商户",
            trigger: "blur",
            required: true,
          },
        ],
        content: [
          {
            required: true,
            message: "请输入通知消息内容",
            trigger: "blur",
          },
        ],
      },
      totalList: [],
      allStores: [],
      storesTotal: 0,
      supplierTotal: 0,
      supplierCurrent: 1,
      storeCurrent: 1,
      newStores: [],
      ruleForm: {
        name: "",
        activityDate: "",
        storeCodeList: [],
        isAll: true,
        content: "",
        toApp: "WYHX",
      },
      list: [],
      allStoreList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      pageStoreSize: 100,
      storePageSize: 100,
      searchCondition: {},
      dialogVisible: false,
      innerDialogVisible: false,
      type: "",
      title: "",
      formData: {
        pageNo: 1,
        pageSize: 100,
      },
      loading: false,
      storeName: "",
      row: {},
      allStoreBasicList: [],
      errValidStore: false,
      errStoreResult: [],
    };
  },
  created() {},
  mounted() {
    this.queryList();
    this.queryStoreBasicList();
  },
  // computed: {
  //   paginatedData() {  
  //     const start = (this.supplierCurrent - 1) * this.pageSize;  
  //     const end = start + this.pageSize;  
  //     return this.ruleForm.storeCodeList.slice(start, end);  
  //   }
  // },
  methods: {
    async getChecked(e) {
      console.log("多选", e);
      this.allStoreList = e;
    },
    fetchData() {
      const start = (this.supplierCurrent - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.ruleForm.storeCodeList = this.ruleForm.storeCodeList.slice(start, end);
    },
    //查询商户下的店铺
    async searchStore(e) {
      console.log("商户店铺", e);
      let params = {
        pageNo: this.storeCurrent,
        pageSize: 40,
        id: e.storeCode,
      };
      const { result } = await this.$store.dispatch(
        "queryStoreCodePage",
        params
      );
      this.ruleForm.storeCodeList = result.records || [];
      this.supplierTotal = result.total;
      this.innerDialogVisible = false;
    },
    async queryStoreBasicList() {
      const { result } = await this.$store.dispatch(
        "queryStoreBasicListComboBox"
      );
      this.allStoreBasicList = result || [];
    },
    async addAllStore() {
      let newArr = this.ruleForm.storeCodeList.concat(this.allStoreList);
      let uniqueArray = this.uniqueByKey(newArr, (item) => item.storeCode);
      console.log(newArr, uniqueArray)
      this.ruleForm.storeCodeList = uniqueArray;
      this.supplierTotal = this.ruleForm.storeCodeList.length;
      this.innerDialogVisible = false;
    },
    async searchAll() {
      let params = {
        pageNo: this.storeCurrent,
        pageSize: 40,
        storeCodeName: this.storename,
      };
      if (this.storename == "") {
        this.$message.error("请输入商户名称");
      } else {
        const { result } = await this.$store.dispatch(
          "queryStoreCodePage",
          params
        );
        console.log("模糊搜索", result);
        this.newStores = result.records || [];
        this.storesTotal = result.total;
        console.log(this.newStores);
        this.innerDialogVisible = true;
      }
    },
    changeToApp(value) {
      console.log(value);
      this.formData = {
        pageNo: 1,
        pageSize: 100,
      };
      this.ruleForm.storeCodeList = [];
      this.storeBasicList = [];
      this.more = false;
      if (value == "WYHX") {
      } else {
        this.querySupplierList(this.formData);
      }
    },
    paging(page) {
      console.log("paging", page);
      this.currentPage = page;
      this.list = [];
      this.queryList();
    },
    uniqueByKey(arr, key) {
      const seen = {};
      return arr.filter((item) => {
        const k = key(item);
        return seen.hasOwnProperty(k) ? false : (seen[k] = true);
      });
    },
    removeSupplier(row) {
      console.log(row);
      this.$confirm("确定删除该商户店铺?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var index;
        while ((index = this.ruleForm.storeCodeList.indexOf(row)) !== -1) {
          this.ruleForm.storeCodeList.splice(index, 1);
        }
        this.supplierTotal--;
      });
    },
    //商户店铺分页
    handleStorePageChange(size) {
      this.storeCurrent = 1;
      this.storePageSize = size;
    },
    storePaging(page) {
      this.storeCurrent = page;
      this.searchAll();
    },
    supplierPaging(page) {
      console.log("supplierPaging", page);
      this.supplierCurrent = page;
      
    },
    handleSizeChange(size) {
      console.log("handleSizeChange", size);
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    remoteMethodSupplier(query) {
      console.log("1111111");
      this.storeName = query;
      if (query !== "") {
        this.storeBasicList = [];
        this.loading = true;
        this.more = false;
        this.formData = {
          pageNo: 1,
          pageSize: 100,
          keyWords: this.storeName,
        };
        this.querySupplierList(this.formData);
      }
    },
    async querySupplierList(formData) {
      try {
        if (this.more) {
          return;
        }
        const { result } = await this.$store.dispatch(
          "querySupplierBasicList",
          formData
        );
        this.loading = false;
        // this.storeBasicList = result;
        const { records, total } = result;

        if (!records.length) {
          this.storeBasicList = [];
        }
        this.storeBasicList = [...this.storeBasicList, ...records];
        this.storeBasicList = arrayUnique2(this.storeBasicList, "storeCode");
        this.formData.pageNo++;
        if (this.storeBasicList.length >= total) {
          this.more = true;
        }
      } catch (error) {
        this.loading = false;
      }
      console.log("this.loading : ", this.loading);
    },
    remoteMethod(query) {
      if (query !== "") {
        this.storeBasicList = this.allStoreBasicList.filter(
          (v) => v.storeName.indexOf(query) > -1
        );
      } else {
        this.storeBasicList = [];
      }
    },
    loadmore() {
      if (this.ruleForm.toApp == "WYHX") {
      } else {
        this.querySupplierList(this.formData);
      }
    },
    // getList(formData) {
    //   // 这里是接口请求数据, 带分页条件
    //   const _res = [1, 2, 3]; // 请求得到的数据
    //   this.options = [...this.options, ..._res];
    // },
    async del(row) {
      const result = await this.$confirm("删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch(
          "supplierWindowMessageInfoDelete",
          {
            id: row.id,
          }
        );
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success",
          });
          this.queryList();
        }
      }
    },
    storerefChange() {
      console.log("this.$refs.storeref: ", this.$refs.storeref);
      console.log("this.storeBasicList:", this.storeBasicList);
    },
    add() {
      this.type = "add";
      this.title = "新增";
      this.dialogVisible = true;
    },
    async copy(row) {
      console.log("看看是啥");
      this.row = row;
      this.type = "add";
      this.title = "新增";
      const { result } = await this.$store.dispatch(
        "supplierWindowMessageInfoDetails",
        {
          id: row.id,
        }
      );
      this.dialogVisible = true;

      for (let key in this.ruleForm) {
        this.ruleForm[key] = result[key];
      }
      result.storeInfoList = result.storeInfoList || [];
      this.ruleForm.activityDate = [result.startTime, result.endTime];

      this.storeBasicList.push(...result.storeInfoList);
      this.storeBasicList = arrayUnique2(this.storeBasicList, "storeCode");
    },
    async edit(row) {
      this.row = row;
      this.title = "编辑";
      this.type = "edit";

      const { result } = await this.$store.dispatch(
        "supplierWindowMessageInfoDetails",
        {
          id: row.id,
        }
      );
      this.dialogVisible = true;

      for (let key in this.ruleForm) {
        this.ruleForm[key] = result[key];
      }
      result.storeInfoList = result.storeInfoList || [];
      this.ruleForm.activityDate = [result.startTime, result.endTime];
      this.ruleForm.storeCodeList = result.storeInfoList;
      this.supplierTotal = result.storeInfoList.length;
      this.storeBasicList.push(...result.storeInfoList);
      this.storeBasicList = arrayUnique2(this.storeBasicList, "storeCode");
    },
    async submitForm(formName) {
      try {
        const valid = await this.$refs[formName].validate();
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.ruleForm));
          params.startTime = this.ruleForm.activityDate[0];
          params.endTime = this.ruleForm.activityDate[1];
          if (this.type === "edit") {
            params.id = this.row.id;
          }
          let cons = params.storeCodeList.map((items) => {
            items = items.storeCode;
            console.log(items)
            return items;
          })
          params.storeCodeList = cons
          console.log(cons)
          console.log("params: ", params);
          let name =
            this.type === "add"
              ? "supplierWindowMessageInfoAdd"
              : "supplierWindowMessageInfoEdit";
          await this.$store.dispatch(name, params);
          this.$message({
            message: "操作成功！",
            type: "success",
          });
          this.handleClose();

          this.queryList();
        }
      } catch (error) {
        return;
      }
    },
    handleClose() {
      this.resetRuleForm();
      this.dialogVisible = false;
    },
    resetRuleForm() {
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields();
          this.ruleForm.content = "";
          this.ruleForm.storeCodeList = [];
        }
      });
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "supplierWindowMessageInfoList",
        params
      );

      const { total, records } = result;
      this.list = records;
      this.total = total;
    },
    // paging(page) {
    //   this.currentPage = page;
    //   this.queryList();
    // },
    // handleSizeChange(size) {
    //   this.currentPage = 1;
    //   this.pageSize = size;
    //   this.queryList();
    // },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商户名称"];
        const data = [];
        exportJsonToExcel(tHeader, data, "通知消息指定商户模板");
      });
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        console.log("result:", result);
        const formatResult = [];
        that.errStoreResult = [];
        result.forEach((v) => {
          formatResult.push(v[0]);
        });
        console.log("formatResult:", formatResult);
        that.ruleForm.storeCodeList = [];
        that.$store
          .dispatch("batchFindStoreBasicInfoList", {
            supplierNameList: formatResult,
          })
          .then((res) => {
            console.log("导入res:", res);
            if (res.code === "0") {
              if (res.result.findList && res.result.findList.length) {
                that.storeBasicList = res.result.findList;
                res.result.findList.forEach((v) => {
                  that.ruleForm.storeCodeList.push(v);
                });
                that.supplierCurrent = 1;
                that.supplierTotal = that.ruleForm.storeCodeList.length;
                that.$message({
                  message: "操作成功！",
                  type: "success",
                });
              }
              if (res.result.notFindList && res.result.notFindList.length) {
                res.result.notFindList.forEach((v) => {
                  that.errStoreResult.push({ storeName: v });
                });
                that.errValidStore = true;
              }
            }
          });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
  },
};
</script>

<style scoped lang="scss">
</style>
